import styled, { css } from 'styled-components';

import PartNumberSelect from '../../../commonComponentsMC/PartNumberSelect';
import { makeBlankSpec } from '../../../../helpers/setting';
import {
  flexBoxCenter,
  justifyContentSpaceAround,
  layerA,
} from '../../../styles/commonStyles';

const samePartNumber = (a, b) =>
  String(a ?? '').trim().toUpperCase() === String(b ?? '').trim().toUpperCase();

const HeatLoadSpecRow = ({
  options,
  handleSelectedPartNumber,
  selectedSSRIdx,
  SSR,
  elIdx,
  elementIdx,
  el,
}) => {
  const catalogue = options ?? [];

  const partNumbers = catalogue.map(({ partNumber }) => partNumber);
  const isOffCatalogue =
    el?.partNumber && !partNumbers.some((pn) => samePartNumber(pn, el.partNumber));

  const handleChange = (partNumber) => {
    const chosen = partNumber
      ? catalogue.find(({ partNumber: pn }) => samePartNumber(pn, partNumber))
      : null;

    handleSelectedPartNumber(
      chosen ?? makeBlankSpec(),
      selectedSSRIdx,
      SSR,
      elIdx,
      elementIdx,
    );
  };

  return (
    <Row>
      <Spec isPartNum={true}>
        <PartNumberSelect
          value={el?.partNumber ?? ''}
          options={isOffCatalogue ? [...partNumbers, el.partNumber] : partNumbers}
          onChange={handleChange}
        />
      </Spec>

      <Flex>
        <Spec isCurrent={true}>
          {el.currentCurrent ? el.currentCurrent + ' ' + 't' : ''}
        </Spec>
        <Spec isCurrent={true}>{el.current ? el.current + ' ' + 'a' : ''}</Spec>
      </Flex>
      <Spec isCommonSize={true}>
        {el.wattage ? el.wattage + ' ' + 'w' : ''}
      </Spec>
      <Spec isCommonSize={true}>
        {el.voltage ? el.voltage + ' ' + 'v' : ''}
      </Spec>
      <Spec isCommonSize={true}>
        {el.lengths ? el.lengths + ' ' + 'ft' : ''}
      </Spec>
      {el.elementName &&
      el.partNumber &&
      el.current &&
      el.wattage &&
      el.voltage &&
      el.lengths ? (
        <Spec isDescription={true}>
          {el.elementName} - {el.partNumber}/{el.current + ' ' + 'a'}/
          {el.wattage + ' ' + 'w'}/{el.voltage + ' ' + 'v'}/
          {el.lengths + ' ' + 'ft'}
        </Spec>
      ) : (
        <Spec isDescription={true}></Spec>
      )}
    </Row>
  );
};

export default HeatLoadSpecRow;

const Row = styled.div`
  width: 84%;
  height: 30px;
  margin-top: 4px;
  ${justifyContentSpaceAround}

  position: relative;
`;

const Flex = styled.div`
  height: 100%;
  display: flex;
  gap: 2px;
`;

const Spec = styled.div`
  height: 100%;

  font-size: 8px;
  letter-spacing: 0.8px;
  text-align: center;

  ${({ isPartNum, isCurrent, isCommonSize, isDescription }) =>
    isPartNum
      ? css`
          width: 76px;
          position: relative;
        `
      : isCurrent
        ? css`
            width: 42px;
          `
        : isCommonSize
          ? css`
              width: 72px;
            `
          : isDescription &&
            css`
              width: 260px;
            `}

  ${layerA}

  border-radius: 12px;

  ${flexBoxCenter}
`;
